var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"padding":"7px 20px","border-radius":"15px","box-shadow":"0 2px 12px 0 rgba(0,0,0,.3)"},attrs:{"type":"warning","size":"middle","round":""},on:{"click":_vm.fun}},[_vm._v(_vm._s(_vm.msg))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b559e1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/btn.vue
// module id = null
// module chunks = 